import React from "react";
import AppText from "../../../../components/AppText";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsSectionCard from "../../shared/DocsSectionCard";

const typoRows = [
  { role: "heading-0", size: "32px", line: "36px", weight: "700", sample: "Page Title" },
  { role: "heading-1", size: "24px", line: "28px", weight: "700", sample: "Detail Title" },
  { role: "heading-2", size: "18px", line: "24px", weight: "700", sample: "Dialog Title" },
  { role: "heading-3", size: "16px", line: "24px", weight: "700", sample: "Card Title" },
  { role: "heading-4", size: "14px", line: "20px", weight: "700", sample: "Section Title" },
  { role: "heading-5", size: "13px", line: "18px", weight: "700", sample: "Compact Title" },
  { role: "label-0", size: "16px", line: "24px", weight: "500", sample: "UI-Beschriftung LG" },
  { role: "label-1", size: "14px", line: "20px", weight: "500", sample: "UI-Beschriftung MD" },
  { role: "label-2", size: "13px", line: "18px", weight: "500", sample: "UI-Beschriftung SM" },
  { role: "label-3", size: "12px", line: "16px", weight: "500", sample: "UI-Beschriftung XS" },
  { role: "body-0", size: "16px", line: "20px", weight: "400", sample: "Subtitle Page" },
  { role: "body-1", size: "14px", line: "20px", weight: "400", sample: "Normaler Inhalt der Software" },
  { role: "body-2", size: "13px", line: "18px", weight: "400", sample: "Meta oder Zusatzinformation" },
  { role: "body-3", size: "12px", line: "16px", weight: "400", sample: "Help Text und kleine Hinweise" },
];

const toneRows = [
  { tone: "primary", label: "primary", text: "Default-Schriftfarbe" },
  { tone: "secondary", label: "secondary", text: "Subtitles, Labels, sekundare Infos" },
  { tone: "tertiary", label: "tertiary", text: "Meta, Help, Counts, ruhige Hinweise" },
  { tone: "inverse", label: "inverse", text: "Text auf dunklen oder brandigen Flächen" },
];

const usageRows = [
  { label: "heading-*", text: "Titelhierarchie für Page, Detail, Dialog, Card und Section." },
  { label: "label-*", text: "UI-Beschriftung für Buttons, Listen, Table Header und dichte Tools." },
  { label: "body-*", text: "Normaler Inhalt und Zusatzinfos: body-1 als Default, body-2/body-3 für Meta, Help und Counts." },
];

const niceToKnowItems = [
  "Überschriften bilden eine klare Hierarchie: je tiefer ein Bereich liegt, desto kleiner wird die Heading-Stufe.",
  "Normaler Inhalt ordnet sich darunter ein und darf visuell nicht grösser oder dominanter wirken als die zugehörige Überschrift.",
];

const niceToKnowCriticalItems = ["body-1 ist die Default-Schrift für normalen Inhalt."];

function TypoRow({ row }) {
  return (
    <div className="ds-docs-typography-scale-row">
      <div className="ds-docs-typography-scale-row__role">{row.role}</div>
      <div className="ds-docs-typography-scale-row__preview">
        <AppText variant={row.role} tone="primary" truncate>
          {row.sample}
        </AppText>
      </div>
      <div className="ds-docs-typography-scale-row__attr">{row.size}</div>
      <div className="ds-docs-typography-scale-row__attr">{row.line}</div>
      <div className="ds-docs-typography-scale-row__attr">{row.weight}</div>
    </div>
  );
}

function ToneRow({ row }) {
  return (
    <div className={`ds-docs-typography-tone ds-docs-typography-tone--${row.tone}`}>
      <span className="ds-docs-typography-tone__dot" aria-hidden="true" />
      <AppText variant="label-2" tone={row.tone}>
        {row.label}
      </AppText>
      <AppText variant="body-2" tone={row.tone === "inverse" ? "inverse" : "secondary"}>
        {row.text}
      </AppText>
    </div>
  );
}

function UsageRow({ row }) {
  return (
    <div className="ds-docs-typography-usage-row">
      <div className="ds-docs-typography-usage-row__label">{row.label}</div>
      <div className="ds-docs-typography-usage-row__text">{row.text}</div>
    </div>
  );
}

export default function TypographyDocs() {
  return (
    <DocsSectionCard title="Typography">
      <div className="ds-docs-typography-sheet">
        <div className="ds-docs-typography-top-grid">
          <section className="ds-docs-typography-block ds-docs-typography-block--scale">
            <div className="ds-docs-typography-block__title">Typo Scale</div>
            <div className="ds-docs-typography-scale">
              <div className="ds-docs-typography-scale__header">
                <span>Role</span>
                <span>Preview</span>
                <span>Size</span>
                <span>Line</span>
                <span>Weight</span>
              </div>
              {typoRows.map((row) => (
                <TypoRow key={row.role} row={row} />
              ))}
            </div>
          </section>

          <div className="ds-docs-typography-side-stack">
            <section className="ds-docs-typography-block">
              <div className="ds-docs-typography-block__title">Textfarben</div>
              <div className="ds-docs-typography-tone-list">
                {toneRows.map((row) => (
                  <ToneRow key={row.tone} row={row} />
                ))}
              </div>
            </section>

            <section className="ds-docs-typography-block ds-docs-typography-block--guide">
              <div className="ds-docs-typography-block__title">Usage Leitfaden</div>
              <div className="ds-docs-typography-usage-list">
                {usageRows.map((row) => (
                  <UsageRow key={row.label} row={row} />
                ))}
              </div>
            </section>

            <DocsNiceToKnow items={niceToKnowItems} criticalItems={niceToKnowCriticalItems} />
          </div>
        </div>
      </div>
    </DocsSectionCard>
  );
}
